import { getToken } from "../../../utils/auth";
import { dev_baseUrl } from "../../../utils/var";

export const SaveRole = async (role, navigate) => {
    const accesstoken = getToken();
    if (accesstoken) {
      try {
        let Payload = {
            roleID: role?.roleID,
            roleName: role?.roleName,
            roleType: role?.roleType,
            roleDescription: role?.description,
            isActive: true,
        };
  
        const response = await fetch(`${dev_baseUrl}/Role/save`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${accesstoken}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(Payload),
        });
  
        const data = await response.json();
        if (!response.ok && !data.isError && data.statusCode === "Unauthorized") {
          navigate(`/login`);
        } else {
          return data;
        }
      } catch (error) {
        console.error("Network error:", error);
        return {
          isError: true,
          message: "An error occurred. Please try again later.",
          error: error,
        };
      }
    } else {
      console.warn("Access token is not available.");
      return { form: "Access token is missing." };
    }
  };
